module.exports = __webpack_public_path__ + "static/media/arrowWhiteRight.2de1c2ad.svg";